/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelperNew.js').customRequest;
  var mergeQueryParams = require('./requestHelperNew.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.baseApiNewUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Usuń warstwy
   * @method
   * @name Api#deleteWarstwy
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   */
  Api.prototype.deleteWarstwy = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    const tempDomain = typeof options === 'object' ? options.domain : options;
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz listę warstw
   * @method
   * @name Api#getWarstwy
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {boolean} parameters.systemowa - Czy wyświetlać tylko systemowe
   * @param {boolean} parameters.readonly - Czy wyświetlać tylko z flagą readonly
   * @param {boolean} parameters.administracyjna - Czy wyświetlać tylko administracyjne
   * @param {boolean} parameters.administracyjnaLubSystemowa - Czy wyświetlać administracyjne lub systemowe
   * @param {boolean} parameters.wektorowa - Czy wyświetlać tylko wektorowe
   * @param {string} parameters.filter_str - Treść filtra
   * @param {boolean} parameters.include_details - Czy zwracać wszystkie parametry
   * @param {string} parameters.control - Parametr kontrolny
   * @param {string} parameters.grupa - Grupa do której należy warstwa
   * @param {boolean} parameters.do_kompozycji - Pokaż warstwy w widoku dodawania kompozycji
   */
  Api.prototype.getWarstwy = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (parameters['order_by'] !== undefined && parameters['order_by'] !== '') {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined) {
      queryParameters['desc'] = parameters['desc'];
    }

    if (parameters['systemowa'] !== undefined) {
      queryParameters['systemowa'] = parameters['systemowa'];
    }

    if (parameters['readonly'] !== undefined) {
      queryParameters['readonly'] = parameters['readonly'];
    }

    if (parameters['administracyjna'] !== undefined) {
      queryParameters['administracyjna'] = parameters['administracyjna'];
    }

    if (parameters['administracyjnaLubSystemowa'] !== undefined) {
      queryParameters['administracyjnaLubSystemowa'] =
        parameters['administracyjnaLubSystemowa'];
    }

    if (parameters['wektorowa'] !== undefined) {
      queryParameters['wektorowa'] = parameters['wektorowa'];
    }

    if (
      parameters['filter_str'] !== undefined &&
      parameters['filter_str'].replace(/\s/g, '').length > 0 &&
      parameters['filter_str'].length > 0
    ) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['include_details'] !== undefined) {
      queryParameters['include_details'] = parameters['include_details'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    if (parameters['grupa'] !== undefined) {
      queryParameters['grupa'] = parameters['grupa'];
    }

    if (parameters['do_kompozycji'] !== undefined) {
      queryParameters['do_kompozycji'] = parameters['do_kompozycji'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Usuń warstwę
   * @method
   * @name Api#deleteWarstwyById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - Id warstwy
   * @param {string} parameters.token - Token
   */
  Api.prototype.deleteWarstwyById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz warstwę
   * @method
   * @name Api#getWarstwyById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.id - ID warstwy
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWarstwyById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Edytuj warstwę
   * @method
   * @name Api#putWarstwyById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - Id warstwy
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   */
  Api.prototype.putWarstwyById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'PUT',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Dodaj warstwę usługową
   * @method
   * @name Api#postWarstwyUslugowe
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {} parameters.body -
   */
  Api.prototype.postWarstwyUslugowe = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_uslugowe',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Dodaj własną warstwę usługową
   * @method
   * @name Api#postWarstwyUslugoweNowa
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {} parameters.body -
   */
  Api.prototype.postWarstwyUslugoweNowa = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_uslugowe/nowa',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Dodaj warstwę użytkownika
   * @method
   * @name Api#postWarstwyUzytkownika
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   */
  Api.prototype.postWarstwyUzytkownika = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_uzytkownika',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz listę eksportów
   * @method
   * @name Api#getWarstwyWektoroweEksport
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {string} parameters.numer_eksportu - numer_eksportu
   * @param {string} parameters.uzytkownik - uzytkownik
   * @param {string} parameters.status - status
   * @param {number} parameters.data_od - Filtruj date od (unix timestamp)
   * @param {number} parameters.data_do - Filtruj date do (unix timestamp)
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWarstwyWektoroweEksport = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (parameters['order_by'] !== undefined && parameters['order_by'] !== '') {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined && parameters['desc'] !== null) {
      queryParameters['desc'] = parameters['desc'];
    }

    if (
      parameters['numer_eksportu'] !== undefined &&
      parameters['numer_eksportu'] !== null
    ) {
      queryParameters['numer_eksportu'] = parameters['numer_eksportu'];
    }

    if (
      parameters['uzytkownik'] !== undefined &&
      parameters['uzytkownik'] !== null
    ) {
      queryParameters['uzytkownik'] = parameters['uzytkownik'];
    }

    if (parameters['status'] !== undefined && parameters['status'] !== null) {
      queryParameters['status'] = parameters['status'];
    }

    if (parameters['data_od'] !== undefined && parameters['data_od'] !== null) {
      queryParameters['data_od'] = parameters['data_od'];
    }

    if (parameters['data_do'] !== undefined && parameters['data_do'] !== null) {
      queryParameters['data_do'] = parameters['data_do'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz eksport warstwy po UUID
   * @method
   * @name Api#getWarstwyWektoroweEksportByUuidByUid
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.uid - UUID eksportu
   */
  Api.prototype.getWarstwyWektoroweEksportByUuidByUid = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/eksport/by_uuid/{uid}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/octet-stream'];

    parameterPath = parameterPath.replace('{uid}', parameters['uid']);

    if (parameters['uid'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: uid'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Sprawdź status eksportu
   * @method
   * @name Api#getWarstwyWektoroweEksportByEid
   * @param {object} parameters - method options and parameters
   * @param {} parameters.eid - ID eksportu
   * @param {string} parameters.token - Token
   */
  Api.prototype.getWarstwyWektoroweEksportByEid = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/eksport/{eid}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{eid}', parameters['eid']);

    if (parameters['eid'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: eid'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz eksport warstwy
   * @method
   * @name Api#getWarstwyWektoroweEksportByEidPobierz
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.eid - ID eksportu
   */
  Api.prototype.getWarstwyWektoroweEksportByEidPobierz = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/eksport/{eid}/pobierz',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/octet-stream'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{eid}', parameters['eid']);

    if (parameters['eid'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: eid'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Eksportuj warstwę wektorową
   * @method
   * @name Api#postWarstwyWektoroweByIdEksport
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   * @param {string} parameters.id - ID warstwy do eksportu
   */
  Api.prototype.postWarstwyWektoroweByIdEksport = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/{id}/eksport',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Usuń obiekty
   * @method
   * @name Api#deleteWarstwyWektoroweByIdObiekty
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID warstwy
   * @param {boolean} parameters.bufor - ID sesji
   * @param {string} parameters.control - Parametr kontrolny
   * @param {string} parameters.token - Token
   * @param {} parameters.body -
   */
  Api.prototype.deleteWarstwyWektoroweByIdObiekty = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/{id}/obiekty',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    parameterPath = parameterPath.replace('{bufor}', parameters['bufor']);

    if (parameters['bufor'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: bufor'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz listę obiektów dla warstwy jako GeoJSON FeatureCollection
   * @method
   * @name Api#getWarstwyWektoroweByIdObiekty
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID warstwy
   * @param {string} parameters.token - Token
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {string} parameters.filter_str - Treść filtra tekstowego pól
   * @param {string} parameters.filter - Treść filtra pól
   * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
   * @param {string} parameters.bbox - Filter bbox "{xmin},{ymin},{xmax},{ymax}"
   * @param {number} parameters.date - Filter daty - unix timestamp
   * @param {string} parameters.scope - Jakie wartości pobierane
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWarstwyWektoroweByIdObiekty = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/{id}/obiekty',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (parameters['order_by'] !== undefined && parameters['order_by'] !== '') {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined) {
      queryParameters['desc'] = parameters['desc'];
    }

    if (
      parameters['filter_str'] !== undefined &&
      parameters['filter_str'].replace(/\s/g, '').length > 0 &&
      parameters['filter_str'].length > 0
    ) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['filter'] !== undefined) {
      queryParameters['filter'] = parameters['filter'];
    }

    /** set default value **/
    queryParameters['rozwiaz_slowniki'] = 'true';

    if (parameters['rozwiaz_slowniki'] !== undefined) {
      queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
    }

    if (parameters['bbox'] !== undefined) {
      queryParameters['bbox'] = parameters['bbox'];
    }

    if (parameters['date'] !== undefined) {
      queryParameters['date'] = parameters['date'];
    }

    if (parameters['scope'] !== undefined) {
      queryParameters['scope'] = parameters['scope'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz listę obiektów dla warstwy jako GeoJSON FeatureCollection
   * @method
   * @name Api#postWarstwyWektoroweByIdObiektyAnaliza
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID warstwy
   * @param {string} parameters.token - Token
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {string} parameters.filter_str - Treść filtra tekstowego pól
   * @param {string} parameters.filter - Treść filtra pól
   * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
   * @param {string} parameters.bbox - Filter bbox "{xmin},{ymin},{xmax},{ymax}"
   * @param {string} parameters.scope - Jakie wartości pobierane
   * @param {string} parameters.control - Parametr kontrolny
   * @param {} parameters.body -
   */
  Api.prototype.postWarstwyWektoroweByIdObiektyAnaliza = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/{id}/obiekty_analiza',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (parameters['order_by'] !== undefined && parameters['order_by'] !== '') {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined) {
      queryParameters['desc'] = parameters['desc'];
    }

    if (
      parameters['filter_str'] !== undefined &&
      parameters['filter_str'].replace(/\s/g, '').length > 0 &&
      parameters['filter_str'].length > 0
    ) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['filter'] !== undefined) {
      queryParameters['filter'] = parameters['filter'];
    }

    /** set default value **/
    queryParameters['rozwiaz_slowniki'] = 'true';

    if (parameters['rozwiaz_slowniki'] !== undefined) {
      queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
    }

    if (parameters['bbox'] !== undefined) {
      queryParameters['bbox'] = parameters['bbox'];
    }

    if (parameters['scope'] !== undefined) {
      queryParameters['scope'] = parameters['scope'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz listę obiektów dla warstwy jako GeoJSON FeatureCollection
   * @method
   * @name Api#getWarstwyWektoroweByIdObiektyNajblizszeWspolrzednych
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID warstwy
   * @param {string} parameters.token - Token
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {string} parameters.filter_str - Treść filtra tekstowego pól
   * @param {string} parameters.filter - Treść filtra pól
   * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
   * @param {string} parameters.bbox - Filter bbox "{xmin},{ymin},{xmax},{ymax}"
   * @param {string} parameters.scope - Jakie wartości pobierane
   * @param {number} parameters.x - Koordynat x punktu
   * @param {number} parameters.y - Koordynat y punktu
   * @param {number} parameters.tolerancja - Tolerancja w metrach
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWarstwyWektoroweByIdObiektyNajblizszeWspolrzednych = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/{id}/obiekty_najblizsze_wspolrzednych',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (parameters['order_by'] !== undefined && parameters['order_by'] !== '') {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined) {
      queryParameters['desc'] = parameters['desc'];
    }

    if (
      parameters['filter_str'] !== undefined &&
      parameters['filter_str'].replace(/\s/g, '').length > 0 &&
      parameters['filter_str'].length > 0
    ) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['filter'] !== undefined) {
      queryParameters['filter'] = parameters['filter'];
    }

    /** set default value **/
    queryParameters['rozwiaz_slowniki'] = 'true';

    if (parameters['rozwiaz_slowniki'] !== undefined) {
      queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
    }

    if (parameters['bbox'] !== undefined) {
      queryParameters['bbox'] = parameters['bbox'];
    }

    if (parameters['scope'] !== undefined) {
      queryParameters['scope'] = parameters['scope'];
    }

    if (parameters['x'] !== undefined) {
      queryParameters['x'] = parameters['x'];
    }

    if (parameters['x'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: x'));
      return deferred.promise;
    }

    if (parameters['y'] !== undefined) {
      queryParameters['y'] = parameters['y'];
    }

    if (parameters['y'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: y'));
      return deferred.promise;
    }

    if (parameters['tolerancja'] !== undefined) {
      queryParameters['tolerancja'] = parameters['tolerancja'];
    }

    if (parameters['tolerancja'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: tolerancja'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz listę obiektów w bbox dla warstwy jako GeoJSON FeatureCollection
   * @method
   * @name Api#postWarstwyWektoroweByIdObiektySelekcja
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID warstwy
   * @param {string} parameters.token - Token
   * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
   * @param {string} parameters.bbox - Filter bbox "{xmin},{ymin},{xmax},{ymax}"
   * @param {string} parameters.scope - Jakie wartości pobierane
   * @param {string} parameters.control - Parametr kontrolny
   * @param {} parameters.body -
   */
  Api.prototype.postWarstwyWektoroweByIdObiektySelekcja = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/{id}/obiekty_selekcja',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    /** set default value **/
    queryParameters['rozwiaz_slowniki'] = 'true';

    if (parameters['rozwiaz_slowniki'] !== undefined) {
      queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
    }

    if (parameters['bbox'] !== undefined) {
      queryParameters['bbox'] = parameters['bbox'];
    }

    if (parameters['scope'] !== undefined) {
      queryParameters['scope'] = parameters['scope'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz eksport wg warstwy i województwa
   * @method
   * @name Api#getWarstwyWektoroweByIdTerytEksportByTeryt
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID warstwy
   * @param {string} parameters.teryt - TERYT województwa
   */
  Api.prototype.getWarstwyWektoroweByIdTerytEksportByTeryt = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/{id}/teryt/eksport/{teryt}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    parameterPath = parameterPath.replace('{teryt}', parameters['teryt']);

    if (parameters['teryt'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: teryt'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz obiekt jako GeoJSON Feature
   * @method
   * @name Api#getWarstwyWektoroweByLayerIdObiektyByFeatureId
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.layer_id - ID warstwy
   * @param {string} parameters.feature_id - UUID obiektu
   * @param {string} parameters.token - Token
   * @param {boolean} parameters.Czy pobierać z bufora edycji - Token
   * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWarstwyWektoroweByLayerIdObiektyByFeatureId = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/{layer_id}/obiekty/{feature_id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{layer_id}', parameters['layer_id']);

    if (parameters['layer_id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: layer_id'));
      return deferred.promise;
    }

    parameterPath = parameterPath.replace(
      '{feature_id}',
      parameters['feature_id']
    );

    if (parameters['feature_id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: feature_id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['Czy pobierać z bufora edycji'] !== undefined) {
      queryParameters['Czy pobierać z bufora edycji'] =
        parameters['Czy pobierać z bufora edycji'];
    }

    /** set default value **/
    queryParameters['rozwiaz_slowniki'] = 'true';

    if (parameters['rozwiaz_slowniki'] !== undefined) {
      queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getWarstwyWektoroweResultDownload = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy_wektorowe/{id}/result',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{layer_id}', parameters['layer_id']);

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id raportu'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz warstwę
   * @method
   * @name Api#getFeatureAttributes
   * @param {wso2_id} parameters.wso2_id - Parametr id usera (email)
   *  * @param {orgid} parameters.orgid - Parametr id organizacji
   *  * @param {layerId} parameters.layerId - Parametr id warstwy
   *  * @param {obiektId} parameters.obiektId - Parametr id obiektu
   */
  Api.prototype.getFeatureAttributesById = function (parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/warstwy/obiekt',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    var layerConv = {
      xrY: 'gp',
      Kok: 'Ay',
      eKB: 'oM',
      LqY: 'qJ',
      kVj: 'DJ',
      NxE: '9b',
      BXE: 'xY',
      yYq: 'Kk',
      jMe: 'eB',
      Je1: 'LY',
      OKZ: 'kj',
      MKO: 'NE',
      EPx: 'BE',
      vPL: 'je',
      Pxw: 'gp',
      '3xO': 'Ay',
      l8y: 'oM',
      m0D: 'qJ',
      VBL: 'DJ',
      np4: '9b',
      '8Jv': 'xY',
      '5v8': 'Kk',
      QK8: 'eB',
      bD1: 'LY',
      GZ2: 'kj',
      rPn: 'NE',
      ZJB: 'BE',
      wm8: 'je',
    };

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['layerId'] !== undefined || parameters['layerId'] !== null) {
      var layerid = parameters['layerId'];
      if (layerConv[layerid] != undefined) layerid = layerConv[layerid];
      queryParameters['layerId'] = layerid;
    }

    if (
      parameters['obiektId'] !== undefined ||
      parameters['obiektId'] !== null
    ) {
      queryParameters['obiektId'] = parameters['obiektId'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
